export const formatValueCurrency = (value: number) => {
  return new Intl.NumberFormat("pt-br", {
    style: "currency",
    currency: "BRL",
  })
    .format(Number(value / 100))
    .replace("R$", "")
    .trim();
};
